import $ from "jquery";
import VerticalAccordion from "./VerticalAccordion";
// import Helpers from './Helpers'
import _clonedeep from "lodash.clonedeep";

export default function () {
    $(document).ready(function () {
        $("[data-accordion-animation]").each(function () {
            _clonedeep(accordion).setup($(this));
        });
    });

    /////////////////////////////////////////////////////////////////////////
    // THIS ACCORDION IS VERY SIMILAR TO Jquery UI based VerticalAccordion.js
    // BUT GIVES MORE CONTROL
    /////////////////////////////////////////////////////////////////////////

    let accordion = {
        $el: null,
        $triggerEl: null,
        key: null,
        isOpen: false,
        height: 0,
        group: null,
        canMultipleOpen: false,
        setup($el) {
            const that = this;
            this.$el = $el;
            this.key = $el.data("accordion-animation");
            this.$triggerEl = $(
                `[data-accordion-animation-handle="${this.key}"]`,
            );
            this.group = $el.data("accordion-animation-group");
            this.canMultipleOpen =
                typeof $el.data("accordion-animation-multiple-open") !==
                "undefined";
            this.isOpen = false;
            this.height = 0;

            this.events();
            this.close();

            // this.$title.addEventListener('click', this.handleClick.bind(this));
            // this.$content.addEventListener('transitionend', this.handleTransition.bind(this));
            // this.$el.addEventListener('transitionend', this.handleTransition.bind(this));
        },
        events() {
            const that = this;

            this.$triggerEl.on("click", function () {
                that.handleClick();
            });
            this.$el.on("transitionend", function () {
                that.handleTransition();
            });
            this.$el.on("accordion-animation-close", function () {
                that.close();
            });
            // this.$el.addEventListener('transitionend', this.handleTransition.bind(this));

            // this.$title.addEventListener('click', this.handleClick.bind(this));
            // this.$content.addEventListener('transitionend', this.handleTransition.bind(this));
        },
        handleClick() {
            // console.log(this.$el)
            this.height = this.$el[0].scrollHeight;

            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },

        close() {
            this.isOpen = false;
            // this.$el.removeClass('accordion-active')
            this.$el[0].classList.remove("accordion-active");
            this.$el[0].style.maxHeight = `${this.height}px`;

            setTimeout(() => {
                this.$el[0].style.maxHeight = `${0}px`;
            }, 1);

            this.updateClasses();
        },

        open() {
            this.isOpen = true;
            this.$el[0].classList.add("accordion-active");
            this.$el[0].classList.remove("accordion-hidden");
            this.$el[0].style.maxHeight = `${0}px`;

            setTimeout(() => {
                this.$el[0].style.maxHeight = `${this.height}px`;
            }, 1);

            this.updateClasses();

            // console.log(this.canMultipleOpen)
            if (!this.canMultipleOpen) {
                $(`[data-accordion-animation-group="${this.group}"]`)
                    .not(this.$el)
                    .each(function () {
                        // console.log($(this))
                        $(this).trigger("accordion-animation-close");
                    });
            }
        },

        handleTransition() {
            if (!this.isOpen) {
                this.$el[0].classList.add("accordion-hidden");
            }

            this.$el[0].style.maxHeight = "";
        },
        updateClasses() {
            const that = this;

            $(`[data-accordion-animation-affected="${this.key}"]`).each(
                function () {
                    // const $that = $(this)

                    const inActiveClass = $(this).data(
                        "accordion-animation-inactive-class",
                    );
                    const inActiveRemoveClass = $(this).data(
                        "accordion-animation-inactive-remove-class",
                    );
                    const activeClass = $(this).data(
                        "accordion-animation-active-class",
                    );
                    const activeRemoveClass = $(this).data(
                        "accordion-animation-active-remove-class",
                    );

                    if (that.isOpen) {
                        $(this)
                            .removeClass(activeRemoveClass)
                            .addClass(activeClass);
                    } else {
                        $(this)
                            .removeClass(inActiveRemoveClass)
                            .addClass(inActiveClass);
                    }
                },
            );
        },
    };
}
